import { extend } from 'flarum/common/extend';
import Session from 'flarum/common/Session';
import HeaderSecondary from 'flarum/forum/components/HeaderSecondary';
import Button from 'flarum/common/components/Button';
import SubscribeModal from './components/SubscribeModal';
import PurchaseModal from './components/PurchaseModal';
import extractText from 'flarum/common/utils/extractText';
import Tooltip from 'flarum/common/components/Tooltip';


// ─────────────────────────────────────────────────────────────────────────────
// State shared across the forum session.
// Populated once after the user logs in / page loads.
// ─────────────────────────────────────────────────────────────────────────────
const stripeState = {
	initialLoad: false,
	loaded: false,
	funder: null,
	purchases: {},
	totalSpent: 0,
	coins: {},
};

function loadStripeData() {
	if (stripeState.loaded) return Promise.resolve();

	return app
		.request({ method: 'GET', url: `${app.forum.attribute('apiUrl')}/stripe/me` })
		.then(data => {
			stripeState.funder       = data.funder;
			stripeState.purchases    = data.purchases || {};
			stripeState.totalSpent   = data.total_spent || 0;
			stripeState.coins        = data.coins || {};
			stripeState.loaded       = true;
			m.redraw();
			console.log(data);
		})
		.catch(() => {
			// Non-fatal — buttons will still show, data just won't pre-populate.
			stripeState.loaded = true;
		});
}

app.initializers.add('kemze-stripe', function () {

	const params = new URLSearchParams(window.location.search);
	if (params.get('stripe') === 'success') {
		// Wait a tick so the alert manager is ready
		setTimeout(() => {
			app.alerts.show(
				{ type: 'success', dismissible: true },
				'Payment successful! Your account has been updated.'
			);
			// Clean up the URL without a page reload
			const clean = window.location.pathname;
			window.history.replaceState({}, '', clean);

			// Reload Stripe state so counts/status are fresh
			stripeState.loaded = false;
			loadStripeData();
		}, 300);
	}

	extend(HeaderSecondary.prototype, 'items', function (items) {
		if (!app.session.user) return;

		const subEnabled  = app.forum.attribute('kemze-stripe.sub_enabled');
		const itemEnabled = app.forum.attribute('kemze-stripe.item_enabled');

		if (!stripeState.initialLoad) {
			loadStripeData();
			stripeState.initialLoad = true;
		}

		if (subEnabled) {
			const sub = stripeState.funder;
			const subLabel = !sub ? 'Become a Funder'
				: (sub.status === 'active' && !sub.ends_at) ? 'Active Funder'
				: sub.ends_at ? 'Pausing Funder'
				: 'Past Funder';

			items.add(
				'kemze-stripe-subscription',
				<Button
				className="Button Button--flat"
				icon={app.forum.attribute('kemze-stripe.sub_icon') || 'fas fa-star'}
				onclick={() => {
					app.modal.show(SubscribeModal, {
						priceId:       app.forum.attribute('kemze-stripe.sub_price_id'),
						priceLabel:    app.forum.attribute('kemze-stripe.sub_price_label'),
						description:   app.forum.attribute('kemze-stripe.sub_description'),
						currentStatus: stripeState.funder,
						totalSpent:    stripeState.totalSpent,
					});
				}}
				>
				{subLabel}
				</Button>,
				10
			);
		}

		if (itemEnabled) {
			const tooltipText = `You have ${stripeState.coins.available} Kemze Coin${stripeState.coins.available !== 1 ? 's' : ''}`;
			const finalLabel  = stripeState.coins.total > 0 ? `${stripeState.coins.available} Kz Coins` : 'Kz Coins';

			items.add(
				'kemze-stripe-item',
				<Tooltip text={tooltipText} position="bottom">
				<Button
				className="Button Button--flat"
				icon={app.forum.attribute('kemze-stripe.item_icon') || 'fas fa-coins'}
				onclick={() => {
					app.modal.show(PurchaseModal, {
						priceId:     app.forum.attribute('kemze-stripe.item_price_id'),
						itemKey:     app.forum.attribute('kemze-stripe.item_price_id'),
						itemName:    app.forum.attribute('kemze-stripe.item_label'),
						priceLabel:  app.forum.attribute('kemze-stripe.item_price_label'),
						description: app.forum.attribute('kemze-stripe.item_description'),
						maxQty:      10,
					});
				}}
				>
				{finalLabel}
				</Button>
				</Tooltip>,
				9
			);
		}
	});

});
